export function objectToQueryString(obj = {}, prefix = '') {
  return Object.keys(obj)
    .map((key) => {
      const value = obj[key]
      const newKey = prefix ? `${prefix}[${key}]` : key // Handles nested keys

      if (typeof value === 'object' && value !== null) {
        return objectToQueryString(value, newKey) // Recursive call for nested objects
      } else {
        return `${encodeURIComponent(newKey)}=${encodeURIComponent(value)}`
      }
    })
    .filter(Boolean) // Removes empty values
    .join('&')
}